<div class="gym-info">
  <mat-card class="gym-prop-card">
    <mat-toolbar class="toolbar-subtitle">
      <mat-toolbar-row>Gym Location Data</mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content>
      <mat-form-field class="w-100">
        <mat-label>EGYM Legacy Gym ID</mat-label>
        <input
          matInput
          placeholder="EGYM Legacy Gym ID"
          disabled="true"
          [ngModel]="gym.gymId || '--'"
          name="gym.gymId"
          id="gym.gymId" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Gym UUID</mat-label>
        <input
          matInput
          placeholder="Gym UUID"
          disabled="true"
          [ngModel]="gym.gymUUID || '--'"
          name="gym.gymUUID"
          id="gym.gymUUID" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Slug</mat-label>
        <input
          matInput
          placeholder="Slug"
          disabled="true"
          [ngModel]="gym.slug"
          name="gym.slug"
          id="gym.slug" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Timezone</mat-label>
        <input
          matInput
          placeholder="Timezone"
          disabled="true"
          [ngModel]="gym.timezone"
          name="gym.timezone"
          id="gym.timezone" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Locale</mat-label>
        <input
          matInput
          placeholder="Locale"
          disabled="true"
          [ngModel]="gym.locale"
          name="gym.locale"
          id="gym.locale" />
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card class="gym-prop-card">
    <mat-toolbar class="toolbar-subtitle">
      <mat-toolbar-row>Gym Chain Data</mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content>
      <mat-form-field class="w-100">
        <mat-label>EGYM Legacy Gym Chain ID</mat-label>
        <input
          matInput
          placeholder="EGYM Legacy Gym Chain ID"
          disabled="true"
          [ngModel]="gym.gymChainId || '--'"
          name="gym.gymChainId"
          id="gym.gymChainId" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Gym Chain UUID</mat-label>
        <input
          matInput
          placeholder="Gym Chain UUID"
          disabled="true"
          [ngModel]="gym.gymChainUUID || '--'"
          name="gym.gymChainUUID"
          id="gym.gymChainUUID" />
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>Gym Chain Name</mat-label>
        <input
          matInput
          placeholder="Gym Chain Name"
          disabled="true"
          [ngModel]="gym.gymChainName"
          name="gym.gymChainName"
          id="gym.gymChainName" />
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</div>
